import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  Button,
  Select,
  Input,
  Slider,
  Typography,
  Row,
  Col,
  Space,
  Modal,
  Form,
  Table,
} from "antd";
import moment from "moment";
import {
  useCreateSupplierMutation,
  useFetchSuppliersListQuery,
  useCreateDeliveryMutation,
  useFetchDeliveriesListQuery,
  useUpdateDeliveryCommentMutation,
} from "./delivery.service";
import { useTranslation } from "react-i18next";
import "./style.css";
import { toast } from "react-toastify";

const { Title, Text } = Typography;
const { Option } = Select;
const { Column } = Table;

export default function DeliveryForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [supplier, setSupplier] = useState("");
  const [invoiceRef, setInvoiceRef] = useState("");
  const [isIntact, setIsIntact] = useState("");
  const [deliveryType, setDeliveryType] = useState("");
  const [temperature, setTemperature] = useState(0);
  const [comment, setComment] = useState("");
  const [commentModalDelivery, setCommentModalDelivery] = useState(null);
  const [commentDraft, setCommentDraft] = useState("");
  const [supplierModalVisible, setSupplierModalVisible] = useState(false);
  const [requestCreateSupplier] = useCreateSupplierMutation();
  const [createDelivery] = useCreateDeliveryMutation();
  const [updateDeliveryComment, { isLoading: isCommentSaving }] =
    useUpdateDeliveryCommentMutation();

  const { data: SuppliersListData = {} } = useFetchSuppliersListQuery();
  const { data: DeliveriesListData = [] } = useFetchDeliveriesListQuery();

  console.log("DeliveriesListData", DeliveriesListData);
  console.log("SuppliersListData", SuppliersListData);
  const [supplierList, setSupplierList] = useState([
    "Supplier A",
    "Supplier B",
  ]);

  const [form] = Form.useForm();

  const handleSubmit = () => {
    if (isIntact === "No" && !comment.trim()) {
      toast.error("Please provide a comment when delivery is not intact");
      return;
    }
    createDelivery({
      supplierName: supplier,
      invoiceRef: invoiceRef,
      isIntact: isIntact,
      deliveryType: deliveryType,
      temperature: temperature,
      comment: comment.trim(),
    });
    toast.success(t("Delivery submitted!"));
    setSupplier("");
    setInvoiceRef("");
    setIsIntact("");
    setDeliveryType("");
    setTemperature(0);
    setComment("");
  };

  const handleAddSupplier = () => {
    form
      .validateFields()
      .then((values) => {
        requestCreateSupplier({
          businessName: values.businessName,
          contactName: values.contactName,
          telephone: values.telephone,
          email: values.email,
          address: values.address,
        });
        setSupplierList((prev) => [...prev, values.businessName]);
        form.resetFields();
        setSupplierModalVisible(false);

        toast.success("Supplier added!");
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (SuppliersListData.length > 0) {
      const suppliers = SuppliersListData.map(
        (supplier) => supplier.businessName
      );
      setSupplierList(suppliers);
    }
  }, [SuppliersListData]);

  return (
    <Card
      className="incident-page"
      bordered={false}
      title={<Title level={4}>{t("DELIVERIES")}</Title>}
      extra={<Text>{moment().format("dddd Do MMMM, h:mm A")}</Text>}
    >
      <Row gutter={[0, 20]} style={{ maxWidth: 400 }}>
        <Col span={24}>
          <Text strong>{t("NAME OF SUPPLIER")}</Text>
          <Select
            style={{ width: "100%" }}
            placeholder="Supplier dropdown"
            value={supplier}
            onChange={setSupplier}
          >
            {supplierList.map((s, i) => (
              <Option key={i} value={s}>
                {s}
              </Option>
            ))}
          </Select>
        </Col>

        <Col span={24}>
          <Text strong>{t("DELIVERY INVOICE REF")}</Text>
          <Input
            placeholder="Enter invoice reference"
            value={invoiceRef}
            onChange={(e) => setInvoiceRef(e.target.value)}
          />
        </Col>

        <Col span={24}>
          <Text strong>
            {t("IS DELIVERY INTACT, IN DATE AND CORRECT QUANTITY?")}
          </Text>
          <Select
            style={{ width: "100%" }}
            placeholder="YES / NO dropdown"
            value={isIntact}
            onChange={setIsIntact}
          >
            <Option value="Yes">{t("Yes")}</Option>
            <Option value="No">{t("No")}</Option>
          </Select>
        </Col>

        <Col span={24}>
          <Text strong>{t("CHILLED, FROZEN OR AMBIENT")}</Text>
          <Select
            style={{ width: "100%" }}
            placeholder="chilled / frozen / ambient dropdown"
            value={deliveryType}
            onChange={setDeliveryType}
          >
            <Option value="Chilled">{t("Chilled")}</Option>
            <Option value="Frozen">{t("Frozen")}</Option>
            <Option value="Ambient">{t("Ambient")}</Option>
          </Select>
        </Col>

        <Col span={24}>
          <Text strong>
            {t("PROBE & RECORD TEMPERATURE OF CHILLED or FROZEN")}
          </Text>
          <Text type="secondary">
            {t("Chilled should be 2–8°C and Frozen should be -12 – -20°C.")}{" "}
            <br />
            {t("Reject if chilled is above 8°C or frozen is above -12°C.")}
          </Text>
          <div
            style={{
              fontSize: "1.5rem",
              textAlign: "center",
              marginTop: 10,
              fontWeight: "bold",
            }}
          >
            {temperature.toFixed(1)}°C
          </div>
          <Slider
            min={-30}
            max={120}
            step={0.1}
            value={temperature}
            onChange={setTemperature}
            tooltipVisible={false}
          />
        </Col>

        <Col span={24}>
          <Text strong>{t("COMMENT") || "Comment"}</Text>
          <Input.TextArea
            rows={3}
            placeholder={
              isIntact === "No"
                ? "Required when delivery is not intact"
                : "Optional comment"
            }
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Col>

        <Col span={24}>
          <Text strong>
            {t("DATE AND TIME WILL BE AUTOMATICALLY RECORDED")}
          </Text>
        </Col>

        <Col span={24}>
          <Space>
            <Button
              type="primary"
              style={{ background: "yellow", color: "#000" }}
              onClick={handleSubmit}
            >
              {t("SUBMIT")}
            </Button>
            <Button
              style={{ background: "#1e1f63", color: "white" }}
              onClick={() => setSupplierModalVisible(true)}
            >
              {t("ADD SUPPLIER")}
            </Button>
          </Space>
        </Col>
      </Row>

      <Table dataSource={DeliveriesListData}>
        <Column
          align="center"
          title={t("Date")}
          dataIndex={"createdAt"}
          render={(date) =>
            new Date(date)
              .toLocaleString("en-GB", {
                year: "numeric",
                month: "long",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })
              .replace(" at", ",")
          }
        />
        <Column
          align="center"
          title={t("Supplier Name")}
          dataIndex={"supplierName"}
        />
        <Column align="center" title={t("Invoice")} dataIndex={"invoiceRef"} />
        <Column align="center" title={t("Type")} dataIndex={"deliveryType"} />
        <Column
          align="center"
          title={t("Temperature")}
          dataIndex={"temperature"}
          render={(temperature) => `${temperature.toFixed(1)}°C`}
        />
        <Column
          align="center"
          title={t("Intact")}
          dataIndex={"isIntact"}
          render={(isIntact) => (isIntact ? "Yes" : "No")}
        />
        <Column
          align="center"
          title={t("Delivery ref / comment")}
          dataIndex={"comment"}
          render={(value, record) => {
            const text =
              typeof value === "string"
                ? value
                : value?.default || value?.en || "";
            return (
              <Button
                type="link"
                onClick={() => {
                  setCommentModalDelivery(record);
                  setCommentDraft(text);
                }}
              >
                {text.trim() ? text : "Add comment"}
              </Button>
            );
          }}
        />
      </Table>

      <Modal
        title={t("Delivery ref / comment")}
        open={!!commentModalDelivery}
        onOk={async () => {
          const saved = commentDraft.trim();
          if (!saved || !commentModalDelivery?._id) {
            toast.error("Please enter a comment");
            return;
          }
          try {
            await updateDeliveryComment({
              id: commentModalDelivery._id,
              comment: saved,
            }).unwrap();
            toast.success("Comment saved");
            setCommentModalDelivery(null);
            setCommentDraft("");
          } catch (e) {
            toast.error("Could not save comment");
          }
        }}
        onCancel={() => {
          setCommentModalDelivery(null);
          setCommentDraft("");
        }}
        confirmLoading={isCommentSaving}
      >
        <Input.TextArea
          rows={3}
          value={commentDraft}
          onChange={(e) => setCommentDraft(e.target.value)}
          placeholder="Add comment"
        />
      </Modal>

      <Modal
        title="Add Supplier"
        open={supplierModalVisible}
        onOk={handleAddSupplier}
        onCancel={() => setSupplierModalVisible(false)}
        okText={t("Add")}
        cancelText={t("Cancel")}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="businessName"
            label={t("Business Name")}
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="contactName"
            label={t("Contact Name")}
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="telephone"
            label={t("Telephone")}
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label={t("Email")}
            rules={[{ required: true, type: "email" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="address"
            label={t("Address")}
            rules={[{ required: true }]}
          >
            <Input.TextArea rows={2} />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
}
